import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  
  // KULLANICI ROLLERİNİ BELİRLEME
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userType = Number(authUser?.Users_Type_ID);

  const isCustomer = userType === 1; // Müşteri
  const isDriver = userType === 2 || userType === 4;   // Sürücü / Çekici
  const isAdmin = userType === 3;    // Admin

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/#" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Anasayfa")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Hesap")}</li>

            {/* Müşterinin sertifikası ve müsaitliği olmaz, sadece sürücü/admin görür */}
            {(isDriver || isAdmin) && (
              <>
                <li>
                  <Link to="/calendar" >
                    <i className="bx bx-calendar"></i>
                    <span>{props.t("Müsaitliğim")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/sertifikalarim" >
                    <i className="bx bx-check-shield"></i>
                    <span>{props.t("Sertifikalarım")}</span>
                  </Link>
                </li>
              </>
            )}

            <li>
              <Link to="/hesabim" >
                <i className="bx bx-user"></i>
                <span>{props.t("Hesabım")}</span>
              </Link>
            </li>

{isAdmin && (
<li>
              <Link to="/projects-create" >
                <i className="bx bx-user"></i>
                <span>{props.t("SSS")}</span>
              </Link>
            </li> )}

            
{isAdmin && (
             <li>
              <Link to="/tasks-create" >
                <i className="bx bx-user"></i>
                <span>{props.t("Hakkımızda")}</span>
              </Link>
            </li>
            )}

            {isAdmin && (
             <li>
              <Link to="/legal-documents" >
                <i className="bx bx-file"></i>
                <span>{props.t("Yasal Metinler")}</span>
              </Link>
            </li>
            )}

            <li>
              <Link to="/#" className="has-arrow">                
                <i className="bx bx-briefcase-alt"></i>
                <span key="t-jobs">{props.t("İşler")}</span>
              </Link>
              <ul className="sub-menu">
               {!isCustomer ?  <li><Link to="/job-list">{props.t("Uygun İşler")}</Link></li> : null }
                
                {/* MÜŞTERİ İSE "TALEPLERİM", DEĞİLSE "GÖREVLERİM" YAZACAK */}
                <li>
                  <Link to="/job-apply">
                    {isCustomer ? props.t("Taleplerim") : props.t("Görevler")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store"></i>
                <span>{props.t("Profilim")}</span>
              </Link>
              <ul className="sub-menu">

                <li>
                  <Link to="/ecommerce-orders">{props.t("Faturalarım")}</Link>
                </li>

                {isDriver && (
                  <li>
                    <Link to="/hakedislerim">{props.t("Hakedişlerim")}</Link>
                  </li>
                )}

                {!isCustomer && (
                  <li>
                    <Link to="/tasks-list">{props.t("Kalite Puanım")}</Link>
                  </li>
                )}

                {!isCustomer && (
                  <li>
                    <Link to="/ecommerce-products">{props.t("Tekliflerim")}</Link>
                  </li>
                )}

                <li>
                  <Link to="/borc-yonetimi">{props.t("Ceza Ödemelerim")}</Link>
                </li>

                <li>
                  <Link to="/ecommerce-customers">{props.t("Faturalandırma Bilgileri")}</Link>
                </li>
                
                {/* Sadece Admin sürücü başvurularını yönetebilir */}
                {isAdmin && (
                  <li>
                    <Link to="/candidate-list">{props.t("Sürücü Başvurusu")}</Link>
                  </li>
                )}

                {/* SADECE MÜŞTERİ VE ADMİN YENİ GÖREV TALEBİ AÇABİLİR */}
                {(isCustomer || isAdmin) && (
                  <li>
                    <Link to="/ecommerce-add-product">
                      {props.t("Yeni Görev Talebi")}
                    </Link>
                  </li>
                )}

              </ul>
            </li>

            {/* YALNIZCA ADMİN GÖREBİLİR */}
            {isAdmin && (
              <>
                <li className="menu-title">{props.t("Yönetim")}</li>
                
                <li>
                  <Link to="/email-inbox">
                    <i className="bx bx-envelope"></i>
                    <span>{props.t("Bildirim Yönetimi")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/blog-list">
                    <i className="bx bxs-detail" />
                    <span>{props.t("Blog Yazıları")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/apps-filemanager" >
                    <i className="bx bx-file"></i>
                    <span>{props.t("Dosya Yöneticisi")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <i className="bx bx-credit-card"></i>
                    <span>{props.t("Ödeme")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/crypto-wallet">{props.t("Sistem Finans")}</Link>
                    </li>
                    <li>
                      <Link to="/surucu-hakedis">{props.t("Sürücü Hakedişleri")}</Link>
                    </li>
                    <li>
                      <Link to="/invoices-list">{props.t("Faturalar")}</Link>
                    </li>
                    <li>
                      <Link to="/borc-yonetimi">{props.t("Borç Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/odemeler">{props.t("Ödemeler")}</Link>
                    </li>
                    <li>
                      <Link to="/fiyat-yonetimi">{props.t("Fiyat & İptal Politikası")}</Link>
                    </li>
                  </ul>

                

                </li>

                <li>
                  <Link to="/#" className="has-arrow ">
                    <i className="bx bxs-user-detail"></i>
                    <span>{props.t("Kullanıcılar")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/contacts-grid">{props.t("Kullanıcı Listesi Grid")}</Link>
                    </li>
                    <li>
                      <Link to="/contacts-list">{props.t("Kullanıcı Listesi")}</Link>
                    </li>
                    <li>
                      <Link to="/contacts-profile">{props.t("Firma Bilgileri")}</Link>
                    </li>
                  </ul>
                </li>
              </>
            )}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));